<template lang="pug">
  .lesson-block.main-block
    .lesson-block__content
      template(v-if="localContent.questionArray[0].question")
        .lesson-block__block(v-for="(v, idx) in $v.setOfAnswers.$each.$iter")
          .lesson-block__upload
            UploadFiles(
              v-if="localContent.questionArray[idx].question.isFileAnswerAllow && !taskChecked  && (!taskAlreadySent || !afterDdl)"
              @getFiles="getFiles($event, {idx: +idx})"
              :fileExt="fileExt"
              :fileMime="fileMime"
              :multiple="true"
              :onlyImages="true"
              buttonText="Загрузить изображения/презентации"
            )
          .lesson-block__markdown.form-item__markdown(
            v-if="localContent.questionArray[idx].question.question"
            v-html="makeHtml(localContent.questionArray[idx].question.question)"
          )

          .-answer-.lesson-block__edit-user(
            :class="{'-task-header-': localContent.questionArray[idx].question.isFileAnswerAllow}"
          )
            p.lesson-block__edit-user__label
              | Ответ

            TextArea(
              v-if="!taskChecked  && (!taskAlreadySent || !afterDdl)"
              v-model="localContent.questionArray[idx].answer.answer"
              @input="getTextArea($event, idx)"
              :error="v.answer.$dirty && !v.answer.required"
              :title="isLink && isLink "
              :maxlength="2000"
              placeholder="Напиши ответ на задание"
            )

            ToggleTextBlock.lesson-block__text.main-block__text.-pre-line-(
              v-else
              :text="answerHTML(idx)"
            )

          .lesson-block__row.-files-row-
            File(
              v-for="file in localContent.questionArray[idx].answer.files" :key="file.id"
              :file="file"
              icon="image"
              :canDelete="!taskChecked  && !afterDdl"
              @deleteFile="addFileToDelete({file, idx: +idx})"
            )

      .lesson-block__buttons(v-if="!taskChecked && (!taskAlreadySent || !afterDdl)")
        Button.-xs-(
          @click="chooseEditType"
          :isLoading="uploadingFiles || sendingAnswers"
        )
          | {{taskAlreadySent && !afterDdl ? 'Изменить ответ' : 'Отправить'}}

        Button.button-action.-disabled-.-xs-(v-if="taskAlreadySent && !afterDdl") На проверке

      .answers-card__footer(v-if="taskChecked || (taskAlreadySent && afterDdl)")
        .answers-card__review
          .answers-card__review-row
            .answers-card__reviewer
              .answers-card__reviewer-person
                .answers-card__person(v-if="validatorName")
                  Avatar(:img="validatorAvatar" circle size="s")
                  .lesson-block__person
                    | {{validatorName}}
                p.main-block__label Комментарий к заданию от проверяющего.

            .answers-card__rating
              p.main-block__label
                | Оценка:
                span.color(v-if="!afterDdl || localContent.questionArray[0].answer.points")
                  |  {{points}}
                span.color(v-else)
                  |  {{pointAfterDdl}}


          ToggleTextBlock.main-block__text.answers-card__text(
            :text="validatingText ? validatingText : 'Проверяющий не оставил комментария'"
          )
    slot


</template>

<script>
import _ from 'lodash';
import File from '@/components/File/File';
import UploadFiles from '@/components/Form/UploadFiles';
import ToggleTextBlock from '@/components/Form/ToggleTextBlock';
import markdownToHtml from '@/functions/converterMarkdownToHtml';
import moment from 'moment-timezone';

import { mapState } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import textToHtmlWithLinks from '@/functions/textToHTMLWithLikns';

moment.locale('ru');

export default {
  components: { File, UploadFiles, ToggleTextBlock },
  props: {
    block: {},
    content: {},
    viewRole: {},
    partId: {},
    isLoading: {
      type: Boolean,
      required: false
    },
    store: {},
    user: {}
  },
  data: () => ({
    sendingAnswers: false,
    localKey: '',
    isRequired: false,
    isLink: false,
    files: [[]],
    setOfAnswers: [
      {
        answer: {}
      }
    ],
    localContent: {
      questionArray: [
        {
          answer: {
            answer: ''
          }
        }
      ],
      taskBlock: {}
    },
    filesToDelete: [],
    uploadingFiles: false,
    fileExt: [],
    fileMime: [
      'image/*',
      'application/vnd.openxmlformats-officedocument.presentationml.presentation'
    ],
    pointAfterDdl: '',
    currentDate: moment.tz(new Date(), 'Europe/Moscow'),
    timer: '',
    afterDdl: ''
  }),
  computed: {
    ...mapState('coursesLesson', {
      storeCurrentLesson: s => s.data.currentLesson
    }),
    sendAndAutoCheck() {
      if (!this.localContent.questionArray) {
        return false;
      }

      let status = false;
      this.localContent.questionArray.forEach(q => {
        if (q.answer.id && q.question.isAutoCheck) {
          status = true;
        }
      });

      return status;
    },
    validatingText() {
      const item = this.localContent.questionArray.find(
        item => item.answer.validatingText
      );
      if (item) {
        return item.answer.validatingText
          ? textToHtmlWithLinks(item.answer.validatingText)
          : '';
      } else {
        return '';
      }
    },
    validatorName() {
      const item = this.localContent.questionArray.find(
        item => item.answer.validatorName
      );
      if (item) {
        return item.answer.validatorName ? item.answer.validatorName : '';
      } else {
        return '';
      }
    },
    validatorAvatar() {
      const item = this.localContent.questionArray.find(
        item => item.answer.validatorAvatar
      );
      if (item) {
        return item.answer.validatorAvatar ? item.answer.validatorAvatar : '';
      } else {
        return '';
      }
    },
    points() {
      const item = this.localContent.questionArray.find(
        item => item.answer.points !== undefined
      );
      if (item) {
        return item.answer.points !== undefined ? item.answer.points : '';
      } else if (this.sendAndAutoCheck) {
        const createdAt = moment.tz(
          this.localContent.questionArray[0].answer.createdAt,
          'Europe/Moscow'
        );
        let beforeDDL = true;
        if (this.localContent.taskBlock.ddl) {
          const ddl = moment(this.localContent.taskBlock.ddl, 'Europe/Moscow');
          beforeDDL = createdAt.format() < ddl.format();
        }
        return beforeDDL
          ? this.localContent.questionArray[0].question.pointsBeforeDdl
          : this.localContent.questionArray[0].question.pointsAfterDdl;
      } else {
        return '';
      }
    },
    taskAlreadySent() {
      if (!this.localContent.questionArray) {
        return false;
      }

      let sent = false;
      this.localContent.questionArray.forEach(q => {
        if (q.answer.id) {
          sent = true;
        }
      });

      return sent;
    },
    taskChecked() {
      if (!this.localContent.questionArray) {
        return false;
      }

      let checked = true;
      this.localContent.questionArray.forEach(q => {
        if (!q.answer.isChecked) {
          checked = false;
        }
      });

      return checked;
    }
  },
  watch: {
    content: {
      deep: true,
      handler() {
        this.setData();
      }
    },
    user() {
      this.setData();
    },
    afterDdl(val) {
      if (val) {
        this.pointAfterDdl =
          this.localContent.questionArray[0].question.pointsAfterDdl;
      }
    }
  },
  mounted() {
    this.setData();
    if (this.afterDdl) {
      this.pointAfterDdl =
        this.localContent.questionArray[0].question.pointsAfterDdl;
    }
  },
  destroyed() {
    clearInterval(this.timer);
    if (this.filesToDelete.length > 0) {
      this.deleteFiles();
    }
  },
  methods: {
    answerHTML(idx) {
      return textToHtmlWithLinks(
        this.localContent.questionArray[idx].answer.answer
      );
    },
    setData() {
      this.localContent = _.cloneDeep(this.content);
      this.localKey = `user=${this.user.id}&part=${this.partId}&content=${this.content.taskBlock.id}`;
      const data = JSON.parse(
        localStorage.getItem(
          `user=${this.user.id}&part=${this.partId}&content=${this.content.taskBlock.id}`
        )
      );

      if (data) {
        const idQuestions = data.questionArray.map(el => el.question.id);
        this.localContent.questionArray = this.localContent.questionArray.map(
          el => {
            if (el.answer.isChecked) {
              return el;
            } else if (idQuestions.includes(el.question.id)) {
              el.answer.answer =
                el.answer.answer ||
                data.questionArray.find(
                  elem => elem.question.id === el.question.id
                ).answer.answer;

              if (el.answer.files) {
                el.answer.files = [
                  ...el.answer.files,
                  ...data.questionArray.find(
                    elem => elem.question.id === el.question.id
                  ).answer.files
                ];
              } else {
                el.answer.files = data.questionArray.find(
                  elem => elem.question.id === el.question.id
                ).answer.files;
              }

              return el;
            }
          }
        );
      }
      this.setOfAnswers = this.localContent.questionArray.map((q, idx) => {
        const object = {
          answer: q.answer.answer ? q.answer.answer : ''
        };

        if (q.question.isLinkForbidden) {
          if (object.answer.length >= 1) {
            object.answer = [object.answer, idx];
            this.getTextArea(q.answer.answer, idx);
          }
        }

        return object;
      });
    },
    chooseEditType() {
      if (this.sendingAnswers) {
        return;
      }

      this.sendingAnswers = true;
      if (this.taskAlreadySent && !this.afterDdl) {
        this.editAnswers();
      } else {
        this.sendAnswers();
      }
    },
    validateData() {
      if (this.viewRole === 'user' || this.isLoading || this.uploadingFiles) {
        this.sendingAnswers = false;
        return false;
      }

      if (this.$v.$invalid) {
        this.$v.$touch();
        this.sendingAnswers = false;
        return false;
      }

      if (this.filesToDelete.length > 0) {
        this.deleteFiles();
      }

      return true;
    },
    async sendAnswers() {
      if (!this.validateData()) {
        return;
      }

      const answers = {
        taskBlock: {
          id: this.block.id,
          type: this.block.type,
          variety: this.block.variety
        },
        setOfAnswers: this.localContent.questionArray
      };
      const answersIds = await this.$store.dispatch(
        'coursesLesson/sendAnswers',
        {
          answers,
          block: this.block,
          partId: this.partId,
          lessonId: this.storeCurrentLesson.id
        }
      );
      if (answersIds) {
        localStorage.removeItem(this.localKey);
        this.setData();
        answersIds.forEach((item, idx) => {
          this.localContent.questionArray[idx].answer.id = item.id;
        });

        this.localContent = { ...this.localContent };
      }
      this.sendingAnswers = false;

      if (!this.storeCurrentLesson) {
        return;
      }

      const newCurrentLesson = _.cloneDeep(this.storeCurrentLesson);
      newCurrentLesson.task.ddl = '';

      await this.$store.dispatch('coursesLesson/setData', {
        path: 'currentLesson',
        value: newCurrentLesson
      });
    },
    async editAnswers() {
      if (!this.validateData()) {
        return;
      }

      const answers = {
        taskBlock: {
          id: this.block.id,
          type: this.block.type,
          variety: this.block.variety
        },
        setOfAnswers: this.localContent.questionArray
      };

      await this.$store.dispatch('coursesLesson/editAnswers', {
        answers,
        block: this.block,
        partId: this.partId
      });
      localStorage.removeItem(this.localKey);
      //this.setData()
      this.sendingAnswers = false;
    },
    async getFiles({ formData }, { idx }) {
      if (this.viewRole === 'user' || this.uploadingFiles) {
        return;
      }

      this.uploadingFiles = true;
      const files = await this.$store.dispatch('ajax/uploadFile', { formData });
      if (files) {
        if (this.localContent.questionArray[idx].answer.files) {
          this.localContent.questionArray[idx].answer.files = [
            ...this.localContent.questionArray[idx].answer.files,
            ...files
          ];
          // Если файлов еще не было
        } else {
          this.localContent.questionArray[idx].answer.files = [...files];

          localStorage.setItem(
            this.localKey,
            JSON.stringify(this.localContent)
          );
        }
      }
      this.uploadingFiles = false;
    },
    async addFileToDelete({ file, idx }) {
      this.filesToDelete.push(file);

      const fileIdx = this.localContent.questionArray[
        idx
      ].answer.files.findIndex(f => f.id === file.id);

      if (fileIdx !== -1) {
        this.localContent.questionArray[idx].answer.files.splice(fileIdx, 1);
        this.localContent.questionArray[idx].answer.files = [
          ...this.localContent.questionArray[idx].answer.files
        ];
      }
      this.localContent = { ...this.localContent };
      this.deleteFiles();
    },
    deleteFiles() {
      const files = this.filesToDelete.map(f => {
        return { id: f.id };
      });
      this.$store.dispatch('coursesLesson/deleteFiles', { files });
      this.filesToDelete = [];
      localStorage.setItem(this.localKey, JSON.stringify(this.localContent));
    },
    makeHtml(value) {
      return markdownToHtml.makeHtml(value);
    },
    checkDate() {
      this.checkIsAfterDdl();
      this.timer = setInterval(() => {
        const now = new Date();
        this.currentDate = moment.tz(now, 'Europe/Moscow');
        this.checkIsAfterDdl();
      }, 10000);
    },
    checkIsAfterDdl() {
      let afterDdl = true;
      if (this.localContent.taskBlock.ddl) {
        const ddl = moment.tz(this.localContent.taskBlock.ddl, 'Europe/Moscow');
        afterDdl = this.currentDate.format() > ddl.format();
      }
      this.afterDdl = afterDdl;
    },
    async getTextArea(value, idx) {
      this.setOfAnswers[idx].answer = [value, idx.toString()];
      this.$v.$touch();
      localStorage.setItem(this.localKey, JSON.stringify(this.localContent));
    }
  },
  validations: {
    setOfAnswers: {
      required,
      $each: {
        answer: {
          required: function (value) {
            this.isLink = '';

            if (
              this.localContent.questionArray[value[1]] &&
              this.localContent.questionArray[value[1]].question.isLinkForbidden
            ) {
              if (
                !required(value[0]) ||
                value[0].match(/(?:https?|file|ftp):\/\/([^/\s]+)[^\s]*/gi)
              ) {
                if (
                  value[0].match(/(?:https?|file|ftp):\/\/([^/\s]+)[^\s]*/gi)
                ) {
                  this.isLink = 'Поле не должно содержать ссылку';
                } else {
                  this.isLink = 'Поле не должно быть пустым';
                }

                return false;
              } else {
                return true;
              }
            } else {
              if (!required(value[0])) {
                this.isLink = 'Поле не должно быть пустым';
              }

              return required(value[0]);
            }
          }
        }
      }
    }
  }
};
</script>
